// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"82":"c2df4906","790":"d04cb1f1"}[chunkId] + ".chunk.js";
};